import axios from 'axios'
// import store from '@/store'
// import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  //   config.headers['X-Token'] = getToken()
  // }
  // config.headers['Content-Type'] = 'application/json'
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    // const res = response.data
    // if (res.code !== 20000) {
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //   }
    //   return Promise.reject('error')
    // } else {
    return response.data
    // }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/api/index.js